import inpockStore from "./assets/images/store_md.png"
import inpockLink from "./assets/images/link_sm.jpg"
import Korail from "./assets/images/korail2.png"

export const projects = [
  {
    img: inpockStore,
    title: "인포크스토어",
    desc: "가장 쉬운 나만의 SNS 스토어 제작 솔루션",
    outlink: "https://inpock.com",
    stack: ["Nuxt.js", "serverless", "AWS", "GCP"]
  },
  {
    img: inpockLink,
    title: "인포크링크",
    desc: "판매&소통 채널을 한 곳에 모아 제공할 수 있는 원링크 마케팅 서비스",
    outlink: "https://link.inpock.com",
    stack: ["TypeScript", "Nuxt.js", "serverless", "AWS", "GCP"]
  },
  {
    img: Korail,
    title: "코레일 예약 라이브러리",
    desc: "명절, 출퇴근 기차표를 손쉽게 예매하자",
    outlink: "https://github.com/GodMoonGoodman/types-korail",
    stack: ["TypeScript"]
  }
]

export const posts = [
  {
    img:
      "https://img.velog.io/images/supermoony/post/a8942372-92ba-4133-9db7-d7df9f80f59a/banner-image.png?w=1024",
    title:
      "[Vue(Nuxt)] 이미지 지연 로딩 구현하기 (feat. custom-directive vs component)",
    desc:
      "custom-directive와 component방식으로 구현하는 이미지 지연로딩에 대해 간단히 비교해보자",
    outlink:
      "https://velog.io/@supermoony/VueNuxt-%EC%9D%B4%EB%AF%B8%EC%A7%80-%EC%A7%80%EC%97%B0-%EB%A1%9C%EB%94%A9-%EA%B5%AC%ED%98%84%ED%95%98%EA%B8%B0-feat.-custom-directive-vs-component",
    stack: ["IntersectionObserver", "LazyImage", "directive", "infinitescroll"]
  }
]
